import { Box, Grid, MenuItem, Stack, Typography } from "@mui/material";
import React, { memo, useContext, useState } from "react";
import Label from "../../../components/label";
import TextInput from "../../../components/textInput";
import CustomCheckbox from "../../../components/checkbox";
import { AppContext } from "../../../lib/Context";
import CustomDropDown from "../../../components/select";

const ElectricityField = ({ onInputChange, values = {}, title, showTitle }) => {
  const isTelecoms = title.includes("Telecoms");
  const isCardProcessing = title === "Card Processing";
  const isMobile = title === "Mobile";

  const showMobileNumber = isTelecoms || isMobile;

  return (
    <Box my={3}>
      {showTitle && <Typography variant="h6">{title}</Typography>}
      <Grid container mt={2} spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Current Supplier"} htmlFor={"current-supplier"} />
          <TextInput
            id={"current-supplier"}
            required
            type={"text"}
            variant={"filled"}
            value={values.currentSupplier || ""}
            name={"currentSupplier"}
            onChange={onInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Contract End Date"} />
          <TextInput
            variant="filled"
            type={"date"}
            name="date"
            value={values.date || ""}
            onChange={onInputChange}
          />
        </Grid>

        {!isCardProcessing && (
          <Grid item xs={12} sm={6} md={3}>
            <Label
              title={showMobileNumber ? "Phone Number" : "Meter Number"}
              htmlFor={"meter-number"}
            />
            <TextInput
              id="meter-number"
              required
              type="text"
              variant="filled"
              placeholder={
                showMobileNumber ? "" : "___ ___ ___ ___ ___ ___ ___ ___"
              }
              value={values.meterNumber || ""}
              name="meterNumber"
              onChange={(e) => {
                const value = e.target.value;
                if (!/^\d*$/.test(value)) {
                  return;
                }
                e.target.setCustomValidity(
                  value.length < 9 || value.length > 14
                    ? `${
                        showMobileNumber ? "Phone" : "Meter"
                      } number must be between 9-14 digits`
                    : ""
                );
                onInputChange(e);
              }}
              inputProps={{ maxLength: 14 }}
              helperText={
                values.meterNumber &&
                (values.meterNumber.length < 9 ||
                  values.meterNumber.length > 14)
                  ? `${
                      showMobileNumber ? "Phone" : "Meter"
                    } number must be between 9-14 digits`
                  : ""
              }
              error={
                values.meterNumber &&
                (values.meterNumber.length < 9 ||
                  values.meterNumber.length > 14)
              }
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={3}>
          <Label
            title={"Monthly / Quarterly Spend"}
            htmlFor={"monthly-spend"}
          />
          <TextInput
            id={"monthly-spend"}
            required
            type={"text"}
            variant={"filled"}
            value={values.monthlySpend || ""}
            name={"monthlySpend"}
            onChange={onInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Notes Selection"} htmlFor={"notes-selection"} />
          <TextInput
            id={"notes-selection"}
            required
            type={"text"}
            variant={"filled"}
            value={values.notesSelection || ""}
            name={"notesSelection"}
            onChange={onInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Follow Up Date"} />
          <TextInput
            variant="filled"
            type={"date"}
            name="followUpDate"
            value={values.followUpDate || ""}
            onChange={onInputChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default memo(ElectricityField);
